<template>
  <div style="width: 100%">
    <div class="txl-card" v-for="(item, index) in list" :key="index">
      <img v-if="item.zp" class="img" :src="item.zp" @click="preImage(item.zp)"/>
      <img v-else class="img" src="@images/xxgk/icon-heard.png" />
      <div class="right">
       <div class="flex-item-space">
         <div class="flex-center">
          <img src="@images/icon-xm.png" class="icon-xm"/>
          {{item.xm}}
          </div>
         <a :href="'tel:'+item.lxfs" style="color:#696969">
           tel:{{item.lxfs}}
         </a>
       </div>
       <div class="zw">
          职务：{{item.zw_dictText}}
       </div>

      </div>
    </div>
  </div>
</template>

<script>
import { ImagePreview } from 'vant'
export default {
  props: {
    list: {
      type: Array,
      default() {
        return []
      },
    },
  },
  data() {
    return {
      listData: [],
      colorList: ['red', 'yellow', 'lightBlue', 'coffe', 'yellow', 'seaBlue', 'darkBlue', 'red', 'yellow', 'lightBlue'],
    }
  },
  watch: {
    list: {
      immediate: true,
      handler() {
        // this.list.map((obj) => {
        //   obj.bgColor = this.getColor()
        //   return obj
        // })
        // console.log(this.list)
        this.listData = this.list
      },
    },
  },
  created() {},
  methods: {
    getColor: function () {
      var num = Math.floor(Math.random() * 10)
      return this.colorList[num]
    },
    splitName: function (name) {
      if (!name) {
        return name
      }
      var stringlength = name.length
      // if(stringlength>2){
      // 	var newstring= name.substring(stringlength-2, stringlength);
      // 	return newstring;
      // }else{
      return name.substring(stringlength - 1, stringlength)
      // }
    },
    preImage(img){
      let list = [];
      list.push(img);
       ImagePreview({
        images: list,
      })
    }
    
    
  },
}
</script>

<style lang="less">
.txl-card {
  background: #ffffff;
  display: flex;
  align-items: center;
  padding: 12px;
  border-bottom: 1px solid #ededed;

  .img {
    width: 80px;
    height: 90px;
    object-fit: contain;
  }

  .heard-name {
    width: 54px;
    height: 54px;
    background-color: #3399ff;
    border-radius: 50%;
    text-align: center;
    line-height: 54px;
    font-size: 18px;
    color: #ffffff;
  }

  .right {
    flex: 1;
    display: flex;
    flex-direction: column;
    height: 90px;
    justify-content: space-between;
    padding-left: 12px;
    font-size: 14px;
    color: #333333;

  }
  .content-p {
    display: flex;
    flex: 1;
    margin-left: 16px;
    margin-right: 16px;
    flex-direction: column;
    height: 50px;
    justify-content: space-between;

    .name {
      font-size: 16px;
      font-weight: 600;
      color: #333333;
      margin-right: 8px;
    }

    .tag {
      background: #3399ff;
      border-radius: 2px;
      color: #ffffff;
      padding: 2px 8px;
    }
    .phone {
      font-size: 14px;
      color: #333333;
    }
    .post {
      margin: 4px 0 8px 0;
      font-size: 12px;
      color: #999999;
    }
  }
}
.flex-center{
  display: flex;
  align-items: center;
}
.flex-item-space{
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.icon-xm{
  width: 18px;
  height: 18px;
  margin-right: 6px;
}

.zw{
  font-size: 13px;
  color: #696969;
}

/*颜色*/
.red {
  background: #d57171 !important;
  color: #fff;
}
.coffe {
  background: #a47466 !important;
  color: #fff;
}
.yellow {
  background: #f7b55e !important;
  color: #fff;
}
.darkBlue {
  background: #558aac !important;
  color: #fff;
}
.lightBlue {
  background: #4da9ec !important;
  color: #fff;
}
.lightCoffe {
  background: #bea487 !important;
  color: #fff;
}
.seaBlue {
  background: #4198e7 !important;
  color: #fff;
}
</style>
